exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title-div[data-v-2f1bcb06] {\n  position: relative;\n}\n.title-div .title[data-v-2f1bcb06]::before {\n  display: inline-block;\n  position: absolute;\n  content: \"\";\n  top: 4px;\n  left: 0;\n  width: 4px;\n  background: #20bf64;\n  height: 16px;\n}\n.title-div .title h2[data-v-2f1bcb06] {\n  display: inline-block;\n  padding-left: 8px;\n  font-size: 16px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f1bcb06","scoped":true,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"javascriptEnabled":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Layout/blockLayout.vue
// module id = c9Bk
// module chunks = 142